import initialState from 'redux/modules/payment/state/initial-state';

const reducer = (state = initialState) => ({
  ...state,
  paymentCards: [],
  paymentCardsLoaded: false,
});

export default reducer;
